import apiConfig from '../apiConfig';

export const getDepartmentsSectionsList = async (at, departmentId) => {
	const response = await apiConfig.post(
		'/API/ADMINISTRATION/LOOKUPS/DEPARTMENTS_SECTIONS/GET_DEPARTMENT_SECTIONS_LIST', 
		{
			Department_Id: departmentId,
			PageSize: 100000,
			PageIndex: 1
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	if (response.data.Status) {
		for (let i in response.data.Data) {
			if (response.data.Data[i].Active_Status_Id === 1) {
				response.data.Data[i].Active_Status_Id = true;
			} else {
				response.data.Data[i].Active_Status_Id = false;
			}
		}
		return response.data.Data;
	}

	return [];
};
